<template>
  <div class="access_point_page">
    <DetachHardwarePopup v-if="detachHardwareData" :popupActive="detachHardwarePopups"
      @popup="detachHardwarePopups = $event" :propsData="detachHardwareData" :deviceId="detachDevId" />

    <vs-prompt title="Confirm Delete" class="export-options" @cancel="cancelConfirmDelete" @accept="acceptDelete"
      accept-text="YES" @close="cancelConfirmDelete" :active="confirmACUDelete" cancel-text="No">
      <div class="flex">
        <h5>The device is not responding. Do you still want to delete it? </h5>
      </div>
    </vs-prompt>
    <vs-prompt title="Export To Excel" class="export-options" @cancel="clearFields" @accept="exportToExcel"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" @input="fileName = $event" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vs-popup class="holamundo" title="Choose ACU Table headers" :active.sync="popups.acu_columns_popup">
      <vs-checkbox v-for="(header, index) in acu_headers" :key="index" class="mb-4 mt-5 custom__checkbox"
        v-model="header.show" :disabled="header.field === 'actions'">{{ header.headerName }}</vs-checkbox>
      <div class="screen_false">
        <vs-button class="mt-4 unimacs_button" @click="changeAcuHeaders" :disabled="isDisabledItems">Submit
        </vs-button>
        <vs-button class="mr-6 mt-4 unimacs_cancel_button" @click="popups.acu_columns_popup = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Choose Access Points headers" :active.sync="popups.point_columns_popup">
      <vs-checkbox v-for="(header, index) in access_point_headers" :key="index" class="mb-4 mt-5 custom__checkbox"
        v-model="header.show" :disabled="header.field === 'actions'">{{ header.headerName }}</vs-checkbox>

      <div class="screen_false">
        <vs-button class="mt-4 unimacs_button" @click="changeApHeaders" :disabled="isDisabledItems">Submit
        </vs-button>

        <vs-button class="mr-6 mt-4 unimacs_cancel_button" @click="popups.point_columns_popup = false">Cancel
        </vs-button>
      </div>
    </vs-popup>

    <AttachHardwarePopup v-if="attachHardData" :popupActive="popups.attachHardwarePopup"
      @popup="popups.attachHardwarePopup = $event" :propsData="attachHardData" :deviceId="deviceId" />

    <AddACU :popupActive="popups.addACUPopup" @popup="popups.addACUPopup = $event" :page="page"
      :page_items_count="itemsPerPage" :page_point="pagePoint" :page_items_count_point="itemsPerPagePoint" />

    <vs-popup class="holamundo popup_width_small ac_point__popup updatee" title="Update ACU / Access Point"
      :active.sync="popups.editACUPopup">
      <UpdateACU :page="page" :page_items_count="itemsPerPage" :page_point="pagePoint" @getData="getData"
        :expansion_boards="expansion_boards" :page_items_count_point="itemsPerPagePoint" v-if="popups.editACUPopup"
        :controllers_boards="controllers_boards" class="popup_width_small" />
    </vs-popup>

    <vs-popup class="react-wizard access-point-wizard holamundo " title="Create Access Point"
      :active.sync="accessPointPopUp" @close="closeWizardModal">
      <div v-if="accessPointPopUp">
        <CreateAPReactWrapper :wizardStep="wizardStep" @changePage="changeWizardPage"
          @createAccessPointWizard="createAccessPointWizard" @closeWizardModal="closeWizardModal"
          @wizardNotification="wizardNotification" :selectedACU="selectedACU" />
        <div class="acu-table-wizard-container vx-row" v-if="wizardStep === '1'">
          <vx-card title="Access Control Unit" v-if="wizardStep === '1'" class="ml-5 mr-5">
            <AcuTableWizard :items="acuData" :headers="acu_headers" @selectAcu="selectAcu" />
            <CustomPaging class="log_page" @pageChanged="changeACUWizardPage($event)" :total="totalPage"
              v-if="totalPage >= 2" />
          </vx-card>
          <div class="actions-block-acu-table ">
            <vs-button class="unimacs_cancel_button mt-5 " @click="closeWizardModal"> Cancel</vs-button>
            <vs-button class="unimacs_button mr-6 mt-5" @click=" changeWizardPage('2')"
              :disabled="!selectedACU">Next</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup class="template-table  holamundo " title="Template List" :active.sync="showTemplatePopUp"
      @close="closeTemplatePopUp">
      <vx-card title="Templates" class=" ml-5 mr-5">
        <TemplateTable :items="templateList" :headers="templateHeader" ref="templateTable" />

        <CustomPaging class="log_page" @pageChanged="nextTemplatePage($event)" :total="totalPageTemplate"
          v-if="totalPageTemplate >= 2" />
        <!-- <vs-button class="unimacs_cancel_button mt-5 close-template-table" @click="closeTemplatePopUp">
          Cancel</vs-button> -->
      </vx-card>

    </vs-popup>

    <vx-card title="Access Points" v-if="apTable">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="actions_block_acuu">
            <div class="add_access_point">
              <vs-button class="unimacs_button mr-5" @click="openTemplatePopUp()">
                Template </vs-button>
              <v-select v-model="itemsPerPagePoint" :options="[15, 50, 100, 500, 1000]"
                class="access-point-table-items select_padding ev_log_lim mr-3" name="ap_type" placeholder="Limit"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false" />
              <vs-button class="unimacs_button mr-5" @click="
                exportType = 'acc_point';
              activePrompt = true;
              " :disabled="access_points && !access_points.length">Export</vs-button>
              <vs-button class="unimacs_button mr-5" @click=" toggleAddAP(!accessPointPopUp)">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 mr-1" />
                Add </vs-button>
              <vs-button class="unimacs_button " @click="popups.point_columns_popup = true" icon-pack="material-icons"
                icon="filter_list"></vs-button>
            </div>
          </div>
          <AcPointTable :items="access_points" :headers="filter_access_point_headers"
            @updateItem="updateAccessPoint($event)" @changeApHeadersPosition="changeApHeadersPosition($event)" />

          <CustomPaging class="log_page" @pageChanged="pagePoint = $event" :total="totalPagePoint" v-show="itemsPerPagePoint < point_count && (access_points && access_points.length)
            ? true
            : false
            " />
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>

import Vue from "vue";
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";
import AcPointTable from "./components/tables/ApTable";
import AcuTableWizard from "./components/tables/AcuTableWizard";
import TemplateTable from "./components/tables/TemplateTable";

import CreateAPReactWrapper from "./components/access-point/CreateAPReactWrapper.vue"

import Table from "../../components/custom/table/Table";
import moduleAccessPoint from "@/store/access-point/moduleAccessPoint";
import moduleGroupZone from "@/store/group-zones/moduleAccessPoint";
import AddDevicePopup from "./components/popups/AddDeviceDragDrop";
import AddACU from "./components/popups/acu/AddACU";
import UpdateACU from "./components/popups/acu/UpdateACUPopup";
import AttachHardwarePopup from "./components/popups/AttachHardwarePopup";
import DetachHardwarePopup from "./components/tabs/acu/update/AttachFromACU.vue";
import CellRendererApActions from "./renderer/CellRendererApActions";
import CellRendererTemplateActions from "./renderer/CellRendererTemplateActions.vue";

import vSelect from "vue-select";

import store from "@/store/access-point/moduleAccessPoint.js";
export default {
  watch: {
    // itemsPerPagePoint() {
    //   // const params = { page: 1, page_items_count: this.accessPointListCount };

    //   // this.$refs.customPaging.resetPage(1);
    //   // if(this.startDate) params.start_from = this.startDate
    //   // if(this.endDate) params.start_to = this.endDate

    //   // this.fetchLogs(params);
    // },
    activePrompt(val) {
      if (!val) {
        this.fileName = "";
      }
    },
    "$store.state.isDisabledAllFields"(val) {
      return this.toggleIsDisabledItems(val);
    },
    "store.state.acu"(val) {
      return this.updateACUData(val);

    },

    "store.state.confirmACUDelete"(val) {
      this.$vs.loading.close();
      this.toggleConfirmACUDelete(val);
      return
    },
    "popups.point_columns_popup"(value) {
      this.access_point_headers = JSON.parse(JSON.stringify(this.ap_header));
      return
    },
    // "popups.acu_columns_popup"(value) {
    //   return this.acu_headers = JSON.parse(JSON.stringify(this.acu_header));
    //   // this.access_point_headers = JSON.parse(JSON.stringify(this.ap_header));
    // },
    "popups.editACUPopup"(value) {
      const user = localStorage.user ? JSON.parse(localStorage.user) : null;
      if (!value && user && this.$socket && this.$socket.$unsubscribe) {
        this.$socket.$unsubscribe(
          `reader_delete/${user.company}/${user.id}/acu/${this.acu_id}`
        );
        this.$socket.$unsubscribe(
          `ext_brd_delete/${user.company}/${user.id}/acu/${this.acu_id}`
        );
        this.$socket.$unsubscribe(
          `ext_brd_update/${user.company}/${user.id}/acu/${this.acu_id}`
        );
      }
      return
    },
    itemsPerPage() {
      const params = {
        page: 1,
        page_items_count: this.itemsPerPage,
      };

      this.fetchAcus(params);
      return
    },
    page() {
      const params = {
        page: this.page,
        page_items_count: this.itemsPerPage,
      };

      this.fetchAcus(params);
      return
    },
    itemsPerPagePoint() {
      const params = {
        page: 1,
        page_items_count: this.itemsPerPagePoint,
      };

      this.fetchPoints(params);
      return
    },
    pagePoint() {
      const params = {
        page: this.pagePoint,
        page_items_count: this.itemsPerPagePoint,
      };

      this.fetchPoints(params);
      return
    },
  },
  methods: {

    connectSocket() {
      if (this.socket && this.socket.on) {
        this.setupSocketListeners();
        return;
      }

      // Socket reinitialized, setting up listeners...
      this.socket = io(`${process.env.VUE_APP_SOCKET_PORT}/`, {
        withCredentials: false,
        query: { token: localStorage.token },
      });
      Vue.use(VueSocketIOExt, this.socket);

      this.$nextTick(() => {
        this.setupSocketListeners();
      });
    },

    setupSocketListeners() {
      if (!this.socket || typeof this.socket.on !== "function") {
        return;
      }


      this.socket.on("connect", () => {
        this.socketConnected = true;
      });

      this.socket.on("disconnect", () => {
        this.socketConnected = false;
        setTimeout(() => {
          this.connectSocket();
        }, 3000);
      });

      const user = localStorage.user ? JSON.parse(localStorage.user) : null;
      if (user && user.company) {
        this.acuDataUpdate(user);
      }
    },
    disconnectSocket() {
      // if (socketInstance) {
      //   console.log("❌ Disconnecting socket...");
      //   socketInstance.disconnect();
      //   socketInstance = null;
      // }
    },


    createAccessPointWizard(data) {
      this.$store.dispatch("accessPoint/createAccessPoint", data).then((res) => {
        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "Added Success",
        });
        this.closeWizardModal()
        this.$vs.loading.close();
        const pointParams = {
          page: this.pagePoint,
          page_items_count: this.itemsPerPagePoint,
        };

        this.fetchPoints(pointParams);
      });
      this.$vs.loading.close();
    },
    wizardNotification({ message, type }) {
      this.$vs.notify({
        time: 7000,
        color: type || "danger",
        title: message || "error",
      });

    },
    selectAcu(element) {
      this.selectedACU = element;
    },
    changeWizardPage(val) {
      this.wizardStep = val;
    },

    closeWizardModal() {
      this.wizardStep = "1";
      this.accessPointPopUp = false;
    },

    toggleAddAP(item) {

      const params = {
        page: this.page,
        page_items_count: this.itemsPerPage,
      };
      this.fetchAcus(params).then(() => {
        this.accessPointPopUp = item;
      });
      // this.accessPointPopUp = item

    },
    toggleIsDisabledItems(val) {
      this.isDisabledItems = val
    },
    updateACUData(val) {
      this.acuData = val;
    },

    pointsList() {
      return { list: this.$store.state.accessPoint.access_points, counts: this.$store.state.accessPoint.access_points_count }
    },
    acuCounts() {
      return this.$store.state.accessPoint.acu_count
    },

    checkAccessPointResource() {
      this.popups.addACUPopup = true;
    },

    toggleConfirmACUDelete(value) {
      this.confirmACUDelete = value
    },
    deleteTemplate(data) {
      // this.deleteApItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${data.name} Template `,
        accept: () => this.deleteTemplateFunction(data),
        acceptText: "Delete",
      });
    },
    deleteTemplateFunction(data) {
      this.$store.dispatch("accessPoint/deleteAccessPointTemplate", { id: data.id }).then((res) => {
        this.getAccessPointTemplateList()
        this.wizardNotification({
          message: "deleted success",
          type: "success"
        })
      })
    },
    nextTemplatePage(event) {
      this.pageTemplate = event
      this.getAccessPointTemplateList()

    },

    openTemplatePopUp() {
      this.showTemplatePopUp = true;
      this.getAccessPointTemplateList()
    },
    closeTemplatePopUp() {
      this.showTemplatePopUp = false;
      if (this.$refs.templateTable) {
        this.$refs.templateTable.cleanup();
      }
    },

    changeDateFormat(data) {
      const time = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var isFirefox = typeof InstallTrigger !== "undefined";
      var isSafari =
        navigator.vendor &&
        navigator.vendor.indexOf("Apple") > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf("CriOS") == -1 &&
        navigator.userAgent.indexOf("FxiOS") == -1;

      var is_OSX = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

      let correct_date;

      if (isFirefox || isSafari || is_OSX) {
        const local = this.$moment
          .utc(data, "YYYY-MM-DD HH:mm:ss")
          .tz(time);

        const momentFormat = this.$moment(local).format("YYYY-MM-DD HH:mm / hh:mmA");
        correct_date = momentFormat;
      } else {
        correct_date = this.$moment(data)
          .tz(time)
          .format("YYYY-MM-DD HH:mm / hh:mmA");
      }

      return correct_date;
    },
    async getAccessPointTemplateList() {
      this.$vs.loading({
        type: "corners",
      });
      this.$store.dispatch("accessPoint/getApTemplateList", { unlimit: false, page: this.pageTemplate, count: 10, default_template: false }).then((res) => {

        this.templateList = res.data.data.map((item, index) => {
          return {
            ...item, count: res.data.count - ((this.pageTemplate - 1) * 10) - index,
            createDate: this.changeDateFormat(item.createDate)
          }
        });
        this.totalPageTemplate = Math.round(res.data.count / 10);
        const sum = res.data.count % 10;
        if (!sum) {
          this.totalPageTemplate = Math.floor(
            res.data.count / 10
          );
        } else {
          this.totalPageTemplate =
            Math.floor(res.data.count / 10) + 1;
        }
        this.$vs.loading.close();
      });

      this.$vs.loading.close();

    },
    async changeApHeadersPosition(data) {
      let newHeader = this.changeOrder([...this.access_point_headers], data);
      const settings = JSON.parse(JSON.stringify(this.settingsStore));
      if (settings.table_headers) {
        settings.table_headers.access_point_headers = newHeader;
      } else {
        settings.table_headers = {
          access_point_headers: newHeader,
        };
      }

      this.access_point_headers = newHeader;
      await this.$store.dispatch("setSettings", settings)
    },

    changeOrder(array, headerOrder) {
      const headerIndexMap = headerOrder.reduce((map, header, index) => {
        map[header] = index;
        return map;
      }, {});
      return array
        .filter(item => headerIndexMap.hasOwnProperty(item.headerName))
        .sort((a, b) => headerIndexMap[a.headerName] - headerIndexMap[b.headerName]);
    },

    async changeApHeaders() {
      const settings = JSON.parse(JSON.stringify(this.settingsStore));
      settings.table_headers.access_point_headers = this.access_point_headers;
      this.ap_header = JSON.parse(JSON.stringify(this.access_point_headers));
      await this.$store.dispatch("setSettings", settings);
      this.popups.point_columns_popup = false;
      this.$root.$emit("refreshAcApTable");
    },

    async changeAcuHeadersOrdered(data) {
      // let newHeader = this.changeOrder([...this.acu_headers], data);
      // const settings = JSON.parse(JSON.stringify(this.settingsStore));
      // if (settings.table_headers) {
      //   settings.table_headers.acu_headers = newHeader;
      // } else {
      //   settings.table_headers = {
      //     acu_headers: newHeader,
      //   };
      // }
      // this.acu_headers = newHeader;
      // await this.$store.dispatch("setSettings", settings)
    },

    async changeAcuHeaders() {
      // const settings = JSON.parse(JSON.stringify(this.settingsStore));
      // settings.table_headers.acu_headers = this.acu_headers;
      // this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
      // await this.$store.dispatch("setSettings", settings);
      // // this.setSettings(settings);
      // this.popups.acu_columns_popup = false;
      // this.$root.$emit("refreshAcuTable");
    },
    activateACU(event) {
      this.$vs.loading({
        type: "corners",
      });
      this.$store.dispatch("accessPoint/activateACU", event.id).then((res) => {
        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "Hardware activated",
        });
        this.$vs.loading.close();
      });
      this.$vs.loading.close();
    },
    editACU(event) {
      if (this.isDisabledItems) {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Please wait synchronization to end",
        });
        return false

      }
      if (event && event.status === "pending") {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "ACU is not activate",
        });
        return false
      }
      // if (!event.disabled) {
      this.$store.dispatch("accessPoint/fetchACU", event.id).then((res) => {
        setTimeout(() => {
          this.acu_id = event.id;
          this.popups.editACUPopup = true;
        }, 200);
      });
      // } else {

      //   this.$vs.notify({
      //     time: 7000,
      //     color: "danger",
      //     title: "ACU is offline",
      //   });
      // }
    },
    copyACU(event) {
      if (event.status === "active") {
        this.copy_acu = event.id;
        let findAction = this.contextMenuActions.find(
          (a) => a.action === "paste"
        );
        findAction.disabled = false;

        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "Configuration successfully copied",
        });
      } else {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Can't copy inactive ACU",
        });
      }
    },
    pastACU(event) {
      if (event.cloud_status === "online") {
        if (event.status === "active") {
          if (this.copy_acu === event.id) {
            this.$vs.notify({
              time: 7000,
              color: "danger",
              title: "Can't paste on the same copied ACU",
            });
          } else if (this.copy_acu) {
            this.$store
              .dispatch("accessPoint/pasteACU", {
                acu_copy: this.copy_acu,
                acu_paste: event.id,
              })
              .then(async () => {
                this.$vs.notify({
                  time: 7000,
                  color: "success",
                  title: "Successfully installed",
                });
                const params = {
                  page: this.page,
                  page_items_count: this.itemsPerPage,
                };

                await this.fetchAcus(params);
              });
          } else {
            this.$vs.notify({
              time: 7000,
              color: "danger",
              title: "At first select ACU for copy",
            });
          }
        } else {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "Can't paste on inactive ACU",
          });
        }
      } else {
        if (this.copy_acu) {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title:
              "The operation could not be completed because the device is not online",
          });
        } else {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "At first select ACU for copy",
          });
        }
      }
    },
    attachACU(event) {
      if (event.status == "no_hardware") {
        this.popups.attachHardwarePopup = true;
        this.$store.dispatch("accessPoint/fetchAttachHardware").then((res) => {
          this.attachHardData = { attach_hard: res.data, device: event };
          this.deviceId = event.id;
        });
      } else {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "You cannot do this on an activated device.",
        });
      }
    },
    deleteAp(event) {
      this.deleteApItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${this.deleteApItem.name} Access Point `,
        accept: this.deleteApFunction,
        acceptText: "Delete",
      });
    },
    deactivateConfirm(event) {
      this.deactivateItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${this.deactivateItem.name} ACU `,
        accept: this.deactivateAcu,
        acceptText: "Delete",
      });
    },
    deactivateAcu() {
      if (this.isDisabledItems) { return false }
      this.$store
        .dispatch("accessPoint/deactivateAcu", this.deactivateItem)
        .then((response) => {
          this.$vs.notify({
            time: 7000,
            color: "success",
            title: "ACU deactivated",
          });
        });
    },
    synchronization(event) {

      this.$store.dispatch("fetchSynchCUPItem", event ? event.id : "").then(() => {
      }).catch((message) => {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: message,
        });
      })
    },

    deleteApFunction() {
      if (this.isDisabledItems) { return false }
      this.$vs.loading({
        type: "corners",
      });
      this.$store
        .dispatch("accessPoint/deleteAccessPoint", { ...this.deleteApItem, page: this.pagePoint })
        .then((res) => {
          this.getData()
          this.$vs.loading.close();
          this.$vs.notify({
            time: 7000,
            color: "success",
            title: "Access Point Deleted",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "Something went wrong!!!",
          });
          this.$vs.loading.close();
        });
    },
    deleteACU(event) {
      this.deleteACUItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${this.deleteACUItem.name} ACU `,
        accept: this.deleteNode,
        acceptText: "Delete",
      });
    },
    async getData() {
      this.$vs.loading({
        type: "corners",
      });
      const pointParams = {
        page: this.pagePoint,
        page_items_count: this.itemsPerPagePoint,
      };
      const params = {
        page: this.page,
        page_items_count: this.itemsPerPage,
      };
      await this.fetchAcus(params);
      await this.fetchPoints(pointParams);

      this.$vs.loading.close();
      this.$root.$emit("refreshAcApTable");

    },
    deleteNode() {
      if (this.isDisabledItems) { return false }

      this.$vs.loading({
        type: "corners",
      });
      this.$store
        .dispatch("accessPoint/deleteACU", this.deleteACUItem)
        .then(async (res) => {
          if (res) {
            this.$vs.notify({
              time: 7000,
              color: "success",
              title: "ACU Deleted",
            });
            await this.getData()
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    updateAccessPoint(event) {
      // if (!event.disabled) {
      this.$store.dispatch("accessPoint/fetchACU", event.acu).then((res) => {
        setTimeout(() => {
          this.popups.editACUPopup = true;
        }, 200);
      });
      // }
    },
    acceptDelete() {

      this.$vs.loading({
        type: "corners",
      });
      this.$store
        .dispatch("accessPoint/deleteACU", { ...this.deleteACUItem, forced: true })
        .then(async (res) => {

          await this.getData()
          this.cancelConfirmDelete()
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.cancelConfirmDelete()
        })
    },

    exportToExcel() {
      const name = this.fileName;

      import("@/vendor/Export2Excel").then((excel) => {
        const list = this.exportType == "acu" ? this.acu : this.access_points;
        const header =
          this.exportType == "acu"
            ? this.acu_headers.map((item) => {
              if (item.field !== "actions") {
                return item.headerName;
              }
            })
            : this.access_point_headers.map((item) => {
              if (item.field !== "actions") {
                return item.headerName;
              }
            });

        const headerVal =
          this.exportType == "acu"
            ? this.acu_headers.map((item) => {
              return item.field;
            })
            : this.access_point_headers.map((item) => {
              return item.field;
            });

        const data = this.formatJson(headerVal, list);
        excel.export_json_to_excel({
          header: header,
          data,
          filename: name,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.clearFields();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },

    cancelConfirmDelete() {
      this.$store.dispatch("accessPoint/closeConfirmModal");
    },
    clearFields() {
      this.filename = null;
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
    detachHardware(event) {
      this.detachHardwarePopups = true;
      const id = event.id;

      this.$store.dispatch("accessPoint/fetchAttachHardware").then((res) => {
        this.detachDevId = id;
        this.detachHardwareData = { attach_hard: res.data, device: event };
      });
    },
    submitScreen() {
      const point_table = localStorage.getItem("point_table");
      this.apTable = point_table == "false" ? false : true;
    },
    changeACUWizardPage(page) {
      this.wizardACUCurrentPage = page;
      const params = {
        page: page,
        page_items_count: 15,
      };
      this.fetchAcus(params)
    },

    async fetchAcus(params) {
      this.$store.dispatch("accessPoint/fetchACUList", params).then((res) => {
        this.$vs.loading.close();

        const sum = this.acu_count % this.itemsPerPage;
        if (!sum) {
          this.totalPage = Math.floor(this.acu_count / this.itemsPerPage);
        } else {
          this.totalPage = Math.floor(this.acu_count / this.itemsPerPage) + 1;
        }
        console.log(this.acu_count, "this.totalPage", this.totalPage);

        this.acuData = res;
        setTimeout(() => {
          this.$root.$emit("refreshAcuTable");
        }, 300);
      });
    },

    acuDataUpdate(user) {
      if (!this.$socket) {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Something Went Wrong",
        });
        window.location.reload();
      }

      this.socket.emit("subscribe", `acu_update_cloud_status/${user.company}`);
      this.socket.on(
        `acu_update_cloud_status/${user.company}`,
        (payload) => {
          let res = JSON.parse(payload)
          res.serial_number = `${res.serial_number}`;
          const pointsData = [...this.pointsList().list];
          const dataAccessPoint = pointsData.map(item => {
            if (`${item.acus.serial_number}` === `${res.serial_number}`) {
              return {
                ...item,

                acus: {
                  ...item.acus,
                  ...res,
                  disabled: res.cloud_status === "offline",
                }
              }
            }
            return item
          })


          const pointParams = {
            page: this.pagePoint,
            page_items_count: this.itemsPerPagePoint,
          };
          this.$store.dispatch("accessPoint/updateACUData", {
            accessPoint: {
              points: dataAccessPoint,
              params: pointParams,
              counts: this.pointsList().counts,
            }
          }).then(() => {
            const timer = setTimeout(() => {
              this.$root.$emit("refreshAcuTable");
            }, 300);
            clearTimeout(timer);
          });
        })
    },

    fetchPoints(params) {

      this.$store.dispatch("accessPoint/fetchAccessPoint", params).then(() => {
        this.$vs.loading.close();

        const sum = this.point_count % this.itemsPerPagePoint;
        if (!sum) {
          this.totalPagePoint = Math.floor(
            this.point_count / this.itemsPerPagePoint
          );
        } else {
          this.totalPagePoint =
            Math.floor(this.point_count / this.itemsPerPagePoint) + 1;
        }

        setTimeout(() => {
          this.$root.$emit("refreshAcApTable");
        }, 300);
      });
    },

    addMissingFields(mainArray, updatedArray) {
      const newFelids = updatedArray.map(item => {
        if (item.field === "sync_status") {
          return { ...item, cellRendererFramework: "CellRendererSynchStatus" }
        }
        if (item.field === "actions") {
          return {
            ...item,
            pinned: "right",
            lockPinned: true,
            show: true,
            lockPosition: "right",
          }
        }
        return item
      })
      const updatedFields = new Set(newFelids.map(item => item.field));

      const missingFields = mainArray.filter(item => !updatedFields.has(item.field));
      return [...newFelids, ...missingFields];
    },

    mergeArrays(array1, array2) {
      const array1Fields = new Map(array1.map(item => [item.field, item]));
      array2.forEach(item => {
        if (!array1Fields.has(item.field)) {
          array1.push(item);
        }
      });

      return [...array1];
    }

  },
  async created() {
    if (!moduleAccessPoint.isRegistered) {
      this.$store.registerModule("accessPoint", moduleAccessPoint);
      moduleAccessPoint.isRegistered = true;
    }

    if (!moduleGroupZone.isRegistered) {
      this.$store.registerModule("accessPointGroup", moduleGroupZone);
      moduleGroupZone.isRegistered = true;
    }
    this.submitScreen();



    const settings = JSON.parse(JSON.stringify(this.settingsStore));
    if (!settings) {
      await this.$store.dispatch("setSettings", {
        table_headers: {
          access_point_headers: this.access_point_headers,
          // acu_headers: this.acu_headers,
        },
      });
      this.ap_header = JSON.parse(JSON.stringify(this.access_point_headers));
      // this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
    } else {
      if (settings.table_headers) {
        if (settings.table_headers.access_point_headers && this.access_point_headers) {
          settings.table_headers.access_point_headers = this.mergeArrays(settings.table_headers.access_point_headers, this.access_point_headers);
        }

        const saveSettings = { ...settings };

        if (settings.table_headers.access_point_headers) {
          this.ap_header = JSON.parse(
            JSON.stringify(settings.table_headers.access_point_headers)
          );
          this.access_point_headers = JSON.parse(
            JSON.stringify(this.ap_header)
          );
        } else {
          saveSettings.table_headers.access_point_headers =
            this.access_point_headers;
          this.ap_header = JSON.parse(
            JSON.stringify(this.access_point_headers)
          );
        }
        if (settings.table_headers.acu_headers) {
          // this.acu_header = this.acu_headers
          // this.acu_header = this.addMissingFields(this.acu_headers, JSON.parse(
          //   JSON.stringify(settings.table_headers.acu_headers)
          // ));


          // this.acu_headers = JSON.parse(JSON.stringify(this.acu_header));

        } else {
          // saveSettings.table_headers.acu_headers = this.acu_headers;
          // this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
        }
        await this.$store.dispatch("setSettings", saveSettings);
      } else {
        const saveSettings = { ...settings };
        saveSettings.table_headers = {
          access_point_headers: this.access_point_headers,
          // acu_headers: this.acu_headers,
        };
        // this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
        this.ap_header = JSON.parse(JSON.stringify(this.access_point_headers));
        await this.$store.dispatch("setSettings", saveSettings);
      }
    }

    this.$vs.loading({
      type: "corners",
    });
    const pointParams = {
      page: this.pagePoint,
      page_items_count: this.itemsPerPagePoint,
    };
    this.fetchPoints(pointParams);

    const params = {
      page: this.page,
      page_items_count: this.itemsPerPage,
    };

    await this.fetchAcus(params);

    this.$store.dispatch("accessPoint/fetchAccessPointTypes").then((res) => {
      this.$vs.loading.close();
    });

    if (this.acuPermissions && this.acuPermissions.destroyItem) {
      this.contextMenuActions.push({ name: "Delete", action: "delete" });
    }

    if (this.acuPermissions && this.acuPermissions.updateItem) {
      this.contextMenuActions.push({ name: "Edit", action: "updateItem" });
    }
  },

  mounted() {
    this.isDisabledItems = this.$store.state.isDisabledAllFields;
    // this.acuData = store.state.acu;
    this.$root.$on("deleteAccessP", (data) => {
      this.deleteAp(data);
    });
    this.$root.$on("deleteTemplate", (data) => {
      this.deleteTemplate(data);
    });

    this.$root.$on("updateAccessP", (data) => {
      this.updateAccessPoint(data);
    });

    this.$root.$on("activateAcu", (data) => {
      this.activateACU(data);
    });

    this.$root.$on("copyAcu", (data) => {
      this.copyACU(data);
    });

    this.$root.$on("pasteAcu", (data) => {
      this.pastACU(data);
    });

    this.$root.$on("attachHardwareAcu", (data) => {
      this.attachACU(data);
    });

    this.$root.$on("detachHardwareAcu", (data) => {
      this.detachHardware(data);
    });

    this.$root.$on("updateItemAcu", (data) => {
      this.editACU(data);
    });

    this.$root.$on("deleteAcu", (data) => {
      this.deleteACU(data);
    });
    this.$root.$on("closeUpdatePopup", () => {
      this.popups.editACUPopup = false;
    });
    this.$root.$on("synchronization", (data) => {
      this.synchronization(data)
    });


    this.$store.dispatch("accessPoint/fetchAcuModels").then((res) => {
      this.expansion_boards = res.data.expansion_boards;
      this.controllers_boards = res.data.controllers;
      this.$vs.loading.close();
    });
    this.connectSocket(); // Call the function to connect
  },

  data() {
    return {
      expansion_boards: null,
      controllers_boards: null,
      wizardACUCurrentPage: 1,
      socketConnected: false, // Track socket connection status
      accessControlUnitKey: 0,
      accessPointListCount: 50,
      pageTemplate: 1,
      totalPageTemplate: 0,
      accessControlUnitKey: 0,
      acuData: [],
      pointListData: [],
      selectedACU: null,
      wizardStep: "1",
      accessPointPopUp: false,
      confirmACUDelete: false,
      fileName: "",
      ap_name: null,
      port: null,
      address: null,
      boud_rate: null,
      acu_id: null,
      store,
      updateACU_propsData: null,
      attachHardData: null,
      popups: {
        addAccessPointPopup: false,
        addDevicePopup: false,
        attachHardwarePopup: false,
        addACUPopup: false,
        acu_columns_popup: false,
        point_columns_popup: false,
        editACUPopup: false,
        editApPopup: false,
      },
      acuDeleteConfirm: false,
      ap_header: [],
      access_point_headers: [
        {
          headerName: "#",
          field: "count",
          filter: true,
          pinned: "left",
          lockPinned: true,
          lockPosition: "left",
          cellClass: "locked-col",
          maxWidth: 100,
          minWidth: 100,
          width: 100,
          suppressSizeToFit: true,
          show: true,
        },
        {
          headerName: "Name",
          field: "name",
          filter: true,

          minWidth: 130,
          show: true,
        },
        {
          headerName: "ACU Name",
          field: "acu_name",
          filter: true,
          show: true,
        },
        {
          headerName: "Type",
          field: "type",
          filter: true,
          show: true,

        },
        {
          headerName: "Group",
          field: "group",
          filter: true,
          show: true,
        },
        {
          headerName: "Status",
          field: "acu_status",
          filter: true,
          show: true,

          cellRendererFramework: "CellRendererAcuStatus",
        },
        {
          headerName: "Mode",
          field: "mode",
          filter: true,
          show: true,
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "CellRendererApActions",
          filter: false,
          show: true,
          maxWidth: 120,
          minWidth: 120,
          width: 120,
        },
      ],
      components: {
        CellRendererApActions,
      },
      acu_header: [],
      acu_headers: [
        {
          headerName: "#",
          field: "count",
          filter: true,

          pinned: "left",
          lockPinned: true,
          lockPosition: "left",
          cellClass: "locked-col",
          maxWidth: 100,
          width: 100,
          suppressSizeToFit: true,
          show: true,
        },
        {
          headerName: "Name",
          field: "name",
          filter: true,

          minWidth: 160,
          width: 160,
          show: true,
        },
        {
          headerName: "Slots",
          field: "slots",
          filter: true,
          show: true,
          cellRendererFramework: "CellRendererAcuSlot",
          minWidth: 150,
          width: 150,
        },
        {
          headerName: "Model",
          field: "model",
          filter: true,

          minWidth: 140,
          width: 140,
          show: true,
        },
        {
          headerName: "ACU Serial Number",
          field: "serial_number",
          filter: true,

          minWidth: 220,
          width: 220,
          show: true,
        },
        {
          headerName: "Cloud Connection",
          field: "cloud_status",
          filter: true,
          show: true,
          cellRendererFramework: "CellRendererCloudStatus",
          minWidth: 200,
          width: 200,
        },
        {
          headerName: "IP Address",
          field: "ip_address",
          filter: true,
          show: true,

          minWidth: 150,
          width: 150,
        }


      ],
      contextMenuActions: [
        { name: "Activate", action: "activate" },
        { name: "Copy", action: "copy" },
        { name: "Paste", action: "paste", disabled: true },
        { name: "Attach Hardware", action: "attachHardware" },
        { name: "Change Acu", action: "detachHardware" },
      ],
      contextMenuAPActions: [
        { name: "Delete", action: "delete" },
        { name: "Edit", action: "updateItem" },
      ],
      deleteACUItem: null,
      apTable: true,
      deleteApItem: null,
      acuTable: true,
      deviceId: null,
      upd_acu_component: null,
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: [],
      headerVal: [],
      activePrompt: false,
      exportType: "acc_point",
      detachHardwarePopups: false,
      detachHardwareData: null,
      detachDevId: null,
      copy_acu: null,
      paste_acu: null,
      itemsPerPage: 15,
      page: 1,
      totalPage: 0,
      pagePoint: 1,
      totalPagePoint: 0,
      itemsPerPagePoint: 15,
      isDisabledItems: false,
      templateList: [],
      templateHeader: [
        {
          headerName: "#",
          field: "count",
          filter: true,
          pinned: "left",
          lockPinned: true,
          lockPosition: "left",
          cellClass: "locked-col",
          maxWidth: 100,
          minWidth: 100,
          width: 100,
          suppressSizeToFit: true,
          show: true,
        },
        {
          headerName: "Template Name",
          field: "name",
          filter: true,
          show: true,
        },
        {
          headerName: "Access Point Type",
          field: "access_point_type",
          filter: true,
          show: true,
        },
        {
          headerName: "Creation Date",
          field: "createDate",
          filter: true,
          show: true,

        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "CellRendererTemplateActions",
          filter: false,
          show: true,
          maxWidth: 120,
          minWidth: 120,
          width: 120,
          cellRendererParams: {
            contextMenus: [
              { name: "Delete", action: "deleteTemplate" },
              { name: "Edit", action: "updateAccessP", disabled: true },
            ],
          },
        },],
      showTemplatePopUp: false
    };
  },
  computed: {
    // acu() {
    //   return store.state.acu;
    // },
    deleteConfirmModal() {
      this.$vs.loading.close();
      return store.state.confirmACUDelete;
    },
    acu_count() {
      return store.state.acu_count;

    },
    acuPermissions() {
      return localStorage.permissions
        ? JSON.parse(localStorage.permissions).Acu
          ? JSON.parse(localStorage.permissions).Acu.actions
          : null
        : null;
    },
    access_pointPermissions() {
      return localStorage.permissions
        ? JSON.parse(localStorage.permissions).AccessPoint
          ? JSON.parse(localStorage.permissions).AccessPoint.actions
          : null
        : null;
    },
    access_points() {
      return store.state.access_points;
    },
    point_count() {
      return store.state.access_points_count;
    },
    // filter_acu_headers() {
    //   return this.acu_headers.filter((h) => h.show);
    // },
    filter_acu_headers() {
      // return this.acu_header.filter((h) => {
      //   return 'show' in h ? h.show : true;
      // });
    },
    filter_access_point_headers() {
      const HEADER = this.addMissingFields(this.ap_header, this.ap_header)
      return HEADER.filter((h) => {
        return 'show' in h ? h.show : true;
      });
    },
    settingsStore() {
      return this.$store.state.settings;
    },
    totalPages() {
      return this.gridApi && this.gridApi.paginationGetTotalPages
        ? this.gridApi.paginationGetTotalPages()
        : 0;
    },
  },
  components: {
    Table,
    AddDevicePopup,
    AttachHardwarePopup,
    AddACU,
    UpdateACU,
    DetachHardwarePopup,
    vSelect,
    AcPointTable,
    AcuTableWizard,
    TemplateTable,
    CellRendererApActions,
    CellRendererTemplateActions,
    // CreateACUReactWrapper,
    CreateAPReactWrapper
  },

  beforeDestroy() {
    this.$root.$off("refreshAcApTable");
    this.$root.$off("refreshAcuTable");
    this.$root.$off("deleteAccessP");
    this.$root.$off("updateAccessP");
    this.$root.$off("activateAcu");
    this.$root.$off("copyAcu");
    this.$root.$off("pasteAcu");
    this.$root.$off("attachHardwareAcu");
    this.$root.$off("detachHardwareAcu");
    this.$root.$off("updateItemAcu");
    this.$root.$off("deleteAcu");
    this.$root.$off("closeUpdatePopup");
    this.$root.$off("synchronization");
    this.socket.disconnect(); // Disconnect the socket
    this.socket.removeAllListeners(); // Re
  },
};
</script>

<style lang="scss">
@import url("./css/style.css");

.close-template-table {
  left: 85%;
}

.access-point-table-items {
  min-width: 85px;
}

.template-table {
  .vs-popup {
    min-height: 350px;
    width: 100%;
    max-width: 950px;
  }

  .vs-popup--content {
    .vx-card {
      width: auto;
    }
  }
}


.react-wizard {
  .vs-popup {
    width: 90%;
    max-width: 1350px;

  }

  .acu-table-wizard-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1350px;
    height: 100%;

    .actions-block-acu-table {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      gap: 12px;
      margin-bottom: 20px;

    }
  }

}

.react-wizard {
  width: 100%;

  .vs-popup ::-webkit-scrollbar {
    width: 8px;
  }

  .vs-popup ::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }

  .vs-popup ::-webkit-scrollbar-thumb {
    background: #7367f0;
    border-radius: 4px;
  }

}

.access_point_page {
  .vx-card__header {
    position: absolute;
  }

  .table_block {
    .table_title {
      margin-top: 40px;
    }

    table {
      td {
        padding-top: 10px;
      }

      margin-top: 10px;
      width: 100%;
    }
  }

  .select_block {
    display: flex;
    margin: -15px;

    .v-select {
      flex: 0 0 33.33%;
      padding: 15px;
    }
  }

  .actions_block_acuu {
    .add_device {
      margin-left: 15px;
    }
  }

  .add_access_point {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .popup_width_small {
    .vs-popup--content {
      padding-bottom: 0 !important;
    }

    .vs-popup {
      min-width: 1000px;
      min-height: 680px;
      max-height: 750px;
    }
  }
}
</style>

<style lang="scss">
.access-point-wizard {
  .vs-popup--content {
    overflow-x: hidden;
  }
}

.access_point_page {
  position: relative;

  .scr_config_acu {
    position: absolute;
    top: -46px;
    right: 0;

    .button {
      z-index: 9999999;
    }
  }

  .ap_tbl__padding {
    .con-input-search.vs-table--search {
      margin-right: 175px;
      margin-top: -60px;
    }

    .tr-values {
      .vs-table--td {
        padding: 0 15px !important;
      }
    }
  }

  .ap_tbl_padding {
    .con-input-search.vs-table--search {
      margin-right: 320px;
      margin-top: -60px;
    }

    .tr-values {
      .vs-table--td {
        padding: 0 15px !important;
      }
    }
  }

  .scr_config_acu {
    display: flex;
    flex-direction: row-reverse;
  }

  .screen_false {
    display: flex;
    flex-direction: row-reverse;
  }
}

.ac_point__popup .vs-popup {
  min-width: 950px !important;
}

// .ap_ag_grid {
//   height: auto;
// }</style>
